import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Recover from stale bundle references after a rebuild/redeploy: a failed
// chunk load surfaces as a generic cross-origin "Script error." — reload once.
function isChunkError(msg) {
  return /Loading chunk [\d]+ failed|ChunkLoadError|Loading CSS chunk|Failed to fetch dynamically imported module/i.test(msg || "");
}
window.addEventListener("error", (e) => {
  if (isChunkError(e?.message) && !sessionStorage.getItem("chunk_reloaded")) {
    sessionStorage.setItem("chunk_reloaded", "1");
    window.location.reload();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || String(e?.reason || "");
  if (isChunkError(msg) && !sessionStorage.getItem("chunk_reloaded")) {
    sessionStorage.setItem("chunk_reloaded", "1");
    window.location.reload();
  }
});
// Clear the guard after a successful load so future stale chunks can also recover.
window.addEventListener("load", () => {
  setTimeout(() => sessionStorage.removeItem("chunk_reloaded"), 3000);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
